module.exports = __webpack_public_path__ + "static/vid-shot-e28e411f4a51bbbf60455205938051d7.jpg";